import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PromotionService = /** @class */ (function () {
    function PromotionService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    PromotionService.prototype.get_promotionList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_promotionList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    PromotionService.prototype.get_benefitList_top3 = function () {
        var _latestNewsUrl = cmsApi + '/get_benefitList_top3/';
        var _latestNewsBody = {};
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    PromotionService.prototype.get_promotionList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_promotionList/';
        var _getNewsPeriodBody = { IsActive: '1', search: '' };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    PromotionService.prototype.get_promotionList_active = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_promotionList_active/';
        var _getNewsPeriodBody = { IsActive: '1', search: '' };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    PromotionService.prototype.get_benefitList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_benefitList/';
        var _getNewsPeriodBody = { IsActive: '1', search: '' };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    PromotionService.prototype.get_benefitList_active = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_benefitList_active/';
        var _getNewsPeriodBody = { IsActive: '1', search: '' };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    PromotionService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    PromotionService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    PromotionService.ngInjectableDef = i0.defineInjectable({ factory: function PromotionService_Factory() { return new PromotionService(i0.inject(i1.HttpClient)); }, token: PromotionService, providedIn: "root" });
    return PromotionService;
}());
export { PromotionService };
